export const loadingProgressStyle = theme => ({
    contentLoadingSearch: {
        margin: theme.spacing(2),
        textAlign: 'center'
    }
})